import { CustomerEducationLevel } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const educationLevelMessages = defineMessages({
  diploma: {
    defaultMessage: 'Diploma',
    description: 'education level title',
  },
  juniorHighSchool: {
    defaultMessage: 'Junior High School',
    description: 'education level title',
  },
  none: {
    defaultMessage: 'None',
    description: 'education level title',
  },
  postgraduate: {
    defaultMessage: 'Postgraduate',
    description: 'education level title',
  },
  primarySchool: {
    defaultMessage: 'Primary school',
    description: 'education level title',
  },
  seniorHighSchool: {
    defaultMessage: 'Senior High School',
    description: 'education level title',
  },
  university: {
    defaultMessage: 'University',
    description: 'education level title',
  },
})

export function translateEducationLevel(intl: IntlShape, level: CustomerEducationLevel): string {
  switch (level) {
    case CustomerEducationLevel.NONE:
      return intl.formatMessage(educationLevelMessages.none)
    case CustomerEducationLevel.PRIMARY_SCHOOL:
      return intl.formatMessage(educationLevelMessages.primarySchool)
    case CustomerEducationLevel.JUNIOR_HIGH_SCHOOL:
      return intl.formatMessage(educationLevelMessages.juniorHighSchool)
    case CustomerEducationLevel.SENIOR_HIGH_SCHOOL:
      return intl.formatMessage(educationLevelMessages.seniorHighSchool)
    case CustomerEducationLevel.DIPLOMA:
      return intl.formatMessage(educationLevelMessages.diploma)
    case CustomerEducationLevel.UNIVERSITY:
      return intl.formatMessage(educationLevelMessages.university)
    case CustomerEducationLevel.POSTGRADUATE:
      return intl.formatMessage(educationLevelMessages.postgraduate)
  }
}
